import { isToday, isNext } from '@/locales/dates';
import { useLazyGetInstallmentsQuery } from '@/store/msci/msci.api';
import {
  setMsci,
  setAvailableBin,
  setSelectedBin,
  setPaymentPlans,
  setCallSummary,
  setPreSaleBinValid as setPBinValid,
  setPreSaleBinError,
  resetPaymentPlans,
  setSelectedPaymentPlan,
  resetSelectedAndClean,
  setShowed,
  selectMsci,
} from './msci.slice';
import { useDispatch, useSelector } from 'react-redux';

export default function useMsci() {
  const msci = useSelector(selectMsci);

  const [trigger] = useLazyGetInstallmentsQuery();

  const dispatch = useDispatch();

  const setBin = (bin) => {
    dispatch(setAvailableBin(bin));
  };

  const setBinSelected = (bin) => {
    dispatch(setSelectedBin(bin));
  };

  const setPlans = (plans) => {
    dispatch(setPaymentPlans(plans));
  };

  const shouldCallSummary = () => {
    dispatch(
      setCallSummary({
        callSummary: msci.callSummary + 1,
      }),
    );
  };

  const setPreSaleBinValid = (isValid) => {
    dispatch(setPBinValid(isValid));
  };

  const showPreSaleBinError = (showError) => {
    dispatch(setPreSaleBinError(showError));
  };

  const resetPlans = () => {
    dispatch(resetPaymentPlans());
  };

  const selectPaymentPlan = (selected) => {
    dispatch(setSelectedPaymentPlan(selected));
  };

  const resetAndCleanSelected = () => {
    dispatch(resetSelectedAndClean());
  };

  const handleShowed = (value) => {
    dispatch(setShowed(value));
  };

  const load = async (eventId) => {
    try {
      if (eventId) {
        const { data } = await trigger(eventId, false);

        if (!data) {
          dispatch(setMsci(null));
          return;
        }
        const parseData = parseInstallments(data);
        dispatch(setMsci(parseData));
      }
    } catch {}
  };

  return {
    load,
    setPlans,
    shouldCallSummary,
    showPreSaleBinError,
    setPreSaleBinValid,
    resetPlans,
    selectPaymentPlan,
    resetAndCleanSelected,
    setBin,
    setBinSelected,
    handleShowed,
    msci,
  };
}

const parse = (data) => {
  let current = null;

  if (!data) {
    return current;
  }

  if (data?.length > 0) {
    data[0].bank.forEach((bank) => {
      bank.bin.forEach((bin) => {
        if (data.length > 0) {
          if (!current) {
            current = parsePromoData(data[0]);
          }
        }

        current.bines = {
          ...current.bines,
          [`${bin.bin}`]: {
            bank: bank.bank_name,
            card: bin.card_name,
            bin: bin.bin,
          },
        };

        if (!current.banks[bank.bank_name]) {
          current.banks[bank.bank_name] = [bin.card_name];
        } else {
          current.banks[bank.bank_name] = [
            ...current.banks[bank.bank_name],
            bin.card_name,
          ];
        }

        if (!current.binesByBanks[bank.bank_name]) {
          current.binesByBanks[bank.bank_name] = [
            { card_name: bin.card_name, bin: bin.bin, msi: !!bin?.msi },
          ];
        } else {
          current.binesByBanks[bank.bank_name] = [
            ...current.binesByBanks[bank.bank_name],
            { card_name: bin.card_name, bin: bin.bin, msi: !!bin?.msi },
          ];
        }

        current.options = data[0].installment;
      });
    });
  }
  return current;
};

const filterByKind = (data, kind) => data.filter((opt) => opt.kind === kind);

const parseInstallments = (data) => {
  return {
    msi: parse(filterByKind(data, 'msi')),
    preSale: parse(filterByKind(data, 'pre-sale')),
    preSaleMsi: parse(filterByKind(data, 'pre-sale-msi')),
  };
};

// default msi / mci struct data

const parsePromoData = (data) => ({
  startAt: data.start_date,
  endAt: data.end_date,
  minimunPurchase: data.min_purchase || 0,
  isToday: isToday(data.start_date, data.end_date),
  isNext: isNext(data.start_date),
  bines: {},
  banks: {},
  binesByBanks: {},
});
